const config = {
    url: 
    // window.location.hostname === 'co-hedge.com'
    //   ? 'https://api.co-hedge.com/'
       'https://api.gosagame.com/'
};

export default config;